__turbopack_context__.v({
  "bottomless": "Modals-module-sass-module__8jCzdG__bottomless",
  "content": "Modals-module-sass-module__8jCzdG__content",
  "text-content": "Modals-module-sass-module__8jCzdG__text-content",
});
